export default "__VITE_ASSET__CPQYI510__"